/**
 * Leaves interpolated values as they are instead of HTML-escaping them, so "Skin & Laser" does not show as
 * "Skin &amp; Laser". Only for text React renders as a text node, which React escapes itself; never for text
 * that reaches dangerouslySetInnerHTML.
 *
 * Its own module, not re-exported from `@/core/i18n`, so tests that mock `@/core/i18n` still get it.
 */
export const UNESCAPED_INTERPOLATION_FOR_TEXT_NODES = { escapeValue: false } as const;
